import { render, staticRenderFns } from "./BreakoutRoomsSettings.vue?vue&type=template&id=4bad66ca&scoped=true"
import script from "./BreakoutRoomsSettings.vue?vue&type=script&lang=js"
export * from "./BreakoutRoomsSettings.vue?vue&type=script&lang=js"
import style0 from "./BreakoutRoomsSettings.vue?vue&type=style&index=0&id=4bad66ca&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bad66ca",
  null
  
)

export default component.exports